import {
    TasksService
} from '@/common/api.service.js'

export class Task {
    constructor ({
        id = null,
        metas = null,
        task_name = null,
        task_description = null,
        task_user = null,
        task_sector = null,
        task_status = 0,
        task_type = 3,
        task_parent = null,
        task_expiration = null,
        user = null
    } = {}) {
        this.id = id
        this.metas = metas
        this.task_name = task_name
        this.task_sector = task_sector
        this.task_description = task_description
        this.task_user = task_user
        this.task_status = task_status
        this.task_type = task_type
        this.task_parent = task_parent
        this.task_expiration = task_expiration
        this.user = user
    }

    get task_survey () {
        return this.task_survey
    }

    set task_survey (val) {
        this.task_survey = val
    }
}

export function responseAdapter (response) {
    return new Task({
        ...response
    })
}

export function requestAdapter (request) {
    // Destrutturo i metas
    if (request.metas && request.metas.length === 0) {
        var obj = request.metas
        var metas = Object.keys(obj).map((i) => {
            return {
                meta_key: i,
                task_type: request.task_type,
                value: obj[i]
            }
        })
        request.metas = metas
    }

    return request
}

export default {
    getSingle: id => new Promise((resolve, reject) => {
        TasksService.get(id)
            .then(({
                data,
                headers
            }) => {
                resolve({
                    data: data.task,
                    headers
                })
            }).catch(e => {
                reject(e)
            })
    }),
    getList: params => new Promise((resolve, reject) => {
        TasksService.query(params)
            .then(({
                data,
                headers
            }) => {
                resolve({
                    data: data.map(x => responseAdapter(x)),
                    headers
                })
            }).catch(e => {
                reject(e)
            })
    }),
    create: task => new Promise((resolve, reject) => {
        TasksService.create(requestAdapter(task))
            .then((
                data
            ) => {
                resolve(data)
            }).catch(e => {
                reject(e)
            })
    }),
    update: task => new Promise((resolve, reject) => {
        TasksService.update(requestAdapter(task))
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    }),
    delete: id => new Promise((resolve, reject) => {
        TasksService.delete(id)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    })
}
